import React, {Component} from 'react';
import './credit.scss'
export default class credit extends Component {
  render() {    
    return (
      <div className="page-credit">
        Hello credit
      </div>
    )
  }
}